import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { House, Compass, Flag, Storefront, UserCircle } from '@phosphor-icons/react';

const NAV_ITEMS = [
  { key: 'home', path: '/', icon: House, label: 'Feed' },
  { key: 'profile', path: '/profile', icon: UserCircle, label: 'Profile', auth: true },
  { key: 'play', path: '/play', icon: Flag, label: 'Play', auth: true },
  { key: 'shop', path: '/shop', icon: Storefront, label: 'Shop' },
  { key: 'explore', path: '/explore', icon: Compass, label: 'Explore' },
];

export default function BottomNav() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (item) => {
    if (item.key === 'home') return location.pathname === '/';
    if (item.key === 'profile') return location.pathname.startsWith('/profile');
    if (item.key === 'shop') return location.pathname.startsWith('/shop');
    return location.pathname.startsWith(item.path);
  };

  const handleNav = (item) => {
    if (item.auth && !user) { navigate('/auth'); return; }
    if (item.key === 'profile' && user) { navigate(`/profile/${user.user_id}`); return; }
    navigate(item.path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-border h-16 lg:hidden" data-testid="bottom-nav">
      <div className="max-w-lg mx-auto h-full flex items-center justify-around px-2">
        {NAV_ITEMS.map(item => {
          const active = isActive(item);
          return (
            <button
              key={item.key}
              onClick={() => handleNav(item)}
              className={`flex flex-col items-center gap-0.5 px-2 py-1 transition-colors duration-300 ${active ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}`}
              data-testid={`nav-${item.key}`}
            >
              <item.icon size={22} weight={active ? 'fill' : 'regular'} />
              <span className="text-[10px] font-sans font-semibold tracking-wide uppercase">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
